module.exports = __webpack_public_path__ + "media/components/assets/icons/share_lg-3df03747e4c9917c9f5e8e19b1016b92.svg";